import { useCallback } from "react";

export const useHistoryCity = ({
    filterOptions,
    setFilterValues,
    setFilterOptions,
    handleSearch,
}) => {
    const handleHistoryCity = useCallback(
        (data) => {
            if (
                Object.keys(data?.source) === 0 ||
                Object.keys(data?.destination) === 0 ||
                filterOptions?.mainCity?.length === 0
            ) {
                return;
            }

            const toCityList = filterOptions.mainCity.filter(
                (obj) =>
                    obj.FromCityID === data.source.FromCityID
            );

            if (!toCityList.length) return;

            const selectedToCity =
                toCityList.find(
                    (obj) =>
                        obj.ToCityID ===
                        data.destination.ToCityID
                ) || toCityList[0];

            const defFromCity = [toCityList[0]];
            const defToCity = [selectedToCity];

            setFilterValues((prev) => ({
                ...prev,
                fromCity: defFromCity,
                toCity: defToCity,
            }));

            setFilterOptions((prev) => ({
                ...prev,
                toCity: toCityList,
            }));

            handleSearch(
                data.journeyDate,
                defFromCity,
                defToCity,
                true
            );
        },
        [
            filterOptions?.mainCity,
            setFilterValues,
            setFilterOptions,
            handleSearch,
        ]
    );

    return { handleHistoryCity };
};
